/**
 * Persian Number Formatter Utility
 * Converts English digits to Persian digits
 */

const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

function normalizeNumericValue(num) {
  const numericValue = Number(num);
  return Number.isFinite(numericValue) ? numericValue : null;
}

function localizeDigits(value) {
  return value.replace(/\d/g, (digit) => persianDigits[digit]);
}

/**
 * Format number to Persian digits
 * @param {number} num - The number to format
 * @returns {string} - Formatted number with Persian digits
 */
export function formatPersianNumber(num, options = {}) {
  const numericValue = normalizeNumericValue(num);

  if (numericValue === null) return '۰';

  const formatted = new Intl.NumberFormat('en-US', {
    useGrouping: false,
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
    ...options,
  }).format(numericValue);

  return localizeDigits(formatted);
}

/**
 * Format number with thousand separators and Persian digits
 * @param {number} num - The number to format
 * @returns {string} - Formatted number with separators and Persian digits
 */
export function formatPersianNumberWithSeparator(num) {
  const numericValue = normalizeNumericValue(num);

  if (numericValue === null) return '۰';

  const formatted = new Intl.NumberFormat('en-US', {
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  }).format(numericValue);

  return localizeDigits(formatted);
}

/**
 * Convert Persian digits to English digits
 * @param {string} str - String with Persian digits
 * @returns {string} - String with English digits
 */
export function convertPersianToEnglish(str) {
  if (!str) return '';
  const persianToEnglish = {
    '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
    '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
  };
  return str.replace(/[۰-۹]/g, (digit) => persianToEnglish[digit]);
}

export function toPersianDigits(str) {
  if (!str) return '';
  return str.toString().replace(/\d/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'[digit]);
}

export function formatPersianDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('fa-IR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}
